import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import PDAHeader from "src/components/common/Header";
import usePDA1060_R01Store from "./usePDA1060_R01Store";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import PDA1060_R01Info from "./PDA1060_R01Info";
import PDA1060_R01Table from "./PDA1060_R01Table";

/**
 * PDA1060_R01 재고 조회 메인 컨테이너
 * PDA1090_R01과 동일한 구조: 상단 폼, 하단 테이블
 */
interface PDA1060_R01ContainerProps {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

const PDA1060_R01Container = ({ menuNm, menuCd, onBack }: PDA1060_R01ContainerProps) => {
  const { loading, reset } = usePDA1060_R01Store();
  const { handleMenuClick } = usePDAContainer(reset);

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      <PDAHeader menuNm={menuNm} menuCd={menuCd} onBack={onBack} onMenuClick={handleMenuClick} />

      {/* 메인: 상단 폼(나머지) + 하단 테이블(밑에서부터 2/5) */}
      <div className="flex-1 min-h-0 flex flex-col">
        <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
          <PDA1060_R01Info />
        </div>
        <div className="h-[45vh] min-h-0 flex-shrink-0 overflow-hidden min-w-0">
          <PDA1060_R01Table />
        </div>
      </div>

      {loading && <SpinnerOverlay text="조회 중입니다..." />}
    </div>
  );
};

export default PDA1060_R01Container;

